<template>
  <section
    class="price-detail"
    :style="{ 'margin-top': isAllPayType ? '0' : '-0.6rem' }"
    v-if="isAllPayType || isShowCouponItem || discountInfo"
  >
    <ul>
      <li class="item-layout" v-if="isAllPayType">
        <!-- 旧的支付方式：全额支付 订单显示商品总额 -->
        <div class="">
          <label class="label-ui"><span>商品总额</span></label>
          <div class="pf-simbold"><span v-html="price"></span></div>
        </div>
      </li>
      <li class="item-layout" v-if="isShowCouponItem">
        <div>
          <label class="label-ui"><span>优惠券</span></label>
          <div class="coupon-ui" v-if="!couponStatus">
            <span class="no">暂无可用</span>
          </div>
          <div v-else class="coupon-ui" @click="showCouponSheet">
            <div class="best-coupon" v-if="showRcmdTips && selectedCoupon">
              已选推荐优惠
            </div>
            <div class="coupon-select-ctn" v-if="selectedCoupon">
              -&nbsp;&yen;{{ selectedCoupon.couponAmount / 100 }}
            </div>
            <span v-else class="default"
              >{{ useableCouponLength }}张优惠券可用</span
            >
            <i class="icon-arrow-right"></i>
          </div>
        </div>
      </li>
      <li class="item-layout" v-if="discountInfo" :x-d="checkIfSelectDiscount">
        <div>
          <label class="label-ui"><span>促销立减</span></label>
          <div class="coupon-ui">
            <span class="promotion-discount"
              ><span>-&nbsp;</span
              ><span>&yen;{{ discountInfo.promotionPrice / 100 }}</span></span
            >
            <xCheckbox
              v-model="discountChecked"
              :readOnly="discountReadOnly"
              :styleSheet="{
                width: '.32rem',
                height: '.32rem',
                marginLeft: '.20rem'
              }"
              @onChange="handleChanged"
            ></xCheckbox>
          </div>
        </div>
      </li>
    </ul>

    <PopupCoupon :inList="newCouponList" ref="ppc"></PopupCoupon>
  </section>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import xCheckbox from '@/components/checkbox'
import PopupCoupon from '../popup-coupon'
import { E_PROMOTION_TYPE } from '@/config'
import { isEmptyObject, isNonEmptyArray, isNullOrEmpty } from '@/utils'
import couponItemSimplified from '../../coupon/item'

import miniLoading from '@/components/loading'

export default {
  inject: {
    reducePriceTrackParams: {
      default: null
    }
  },
  props: [
    'spuId',
    'skuId',
    'businessId',
    'level4CategoryId',
    'isAllPayType',
    'buyNum',
    'tripCalendar',
    'isNoCalendar',
    'hasUserMatch'
  ],
  data() {
    return {
      discountChecked: false,
      callOnce: false,
      discountReadOnly: false,
      showRcmdTips: true
    }
  },

  watch: {
    price(val) {
      if (this.level4CategoryId) {
        const promTypes = [E_PROMOTION_TYPE.POSITIVE_PRICE]
        this.dispatchCoupons4Confirm({ promTypes, vueInstance: this })
      }
    }
  },

  computed: {
    ...mapState(['confirmProduct', 'isSupportScore', 'payScore']),
    ...mapState('promotionInfo', {
      promotionInfo: n => n.promotionInfo,
      newCouponList: n => n.couponList,
      discountInfo(n) {
        return !this.hasUserMatch && n.discountInfo
      },
      selectedCoupon: n => n.confirmSelCoupon,
      confirmSelDiscount: n => n.confirmSelDiscount, // TODO 和discountInfo 数据一致，可以通过添加一个checked字段来收敛，这样discountChecked 也可以直接依赖该属性，
      useableCouponLength: n => n.couponList.filter(x => !x.disabled).length
    }),
    checkIfSelectDiscount() {
      const t =
        !isNullOrEmpty(this.confirmSelDiscount) &&
        !isEmptyObject(this.confirmSelDiscount)

      this.discountChecked = t

      return t
    },
    /**
     * 营销活动info
     */
    promList() {
      return this.promotionInfo.promList || []
    },

    couponStatus() {
      let {
        skuInfo: { skuSecType, isNoCalendar } = {
          skuSecType: 401,
          isNoCalendar: 1
        }
      } = this.confirmProduct
      if (isNoCalendar === 0) return this.useableCouponLength > 0
      if (
        (skuSecType === 601 || skuSecType === 602) &&
        this.tripCalendar === null
      )
        return false

      return this.useableCouponLength > 0
    },
    price() {
      let { skuInfo: { skuSecType, skuTag } = { skuSecType: 401, skuTag: 6 } } =
        this.confirmProduct
      // if (skuTag == 8 && skuSecType === 601 && this.tripCalendar === null)
      //   return '-'
      if (
        skuTag == 8 &&
        (skuSecType === 601 || skuSecType === 602) &&
        this.tripCalendar === null &&
        this.isNoCalendar
      )
        return '-'

      let { priceInfo: { price } = { price: null } } = this.confirmProduct
      if (this.tripCalendar && this.tripCalendar.price) {
        price =
          this.tripCalendar.customerPrice != null
            ? this.tripCalendar.customerPrice
            : this.tripCalendar.price
      }

      if (this.buyNum && this.buyNum > 1) price = price * this.buyNum
      if (this.isSupportScore) {
        return `${this.payScore}积分`
      } else if (price) {
        return `<i>&yen;</i>${price / 100}`
      } else {
        return 0
      }
    },
    // 团购没有优惠券
    isShowCouponItem() {
      const { ruleType } = this.$route.query
      return (
        // ruleType != E_PROMOTION_TYPE.FLASH_SALE &&
        !this.hasUserMatch &&
        ruleType != E_PROMOTION_TYPE.GROUP_BUY &&
        this.couponStatus
      )
    }
  },
  methods: {
    ...mapMutations('promotionInfo', [
      'setSelectedCoupon',
      'setSelectedDiscount',
      'destroyConfirmPromotions'
    ]),
    ...mapActions('promotionInfo', ['dispatchCoupons4Confirm']),
    async handleChanged({ checked }) {
      // console.log('checkbox emit ', checked)
      this.setSelectedDiscount(checked ? this.discountInfo : null)
      // this.discountChecked = checked
      const loading = miniLoading.loading()
      loading.show()
      const promTypes = []
      if (checked) {
        promTypes.push(E_PROMOTION_TYPE.DISCOUNT)
      }
      await this.dispatchCoupons4Confirm({ promTypes, vueInstance: this })
      loading.hide()
      //埋点
      this.reducePriceTrackParams &&
        this.$$newTrackClick(this.reducePriceTrackParams)
    },
    showCouponSheet() {
      console.log(this.selectedCoupon)
      this.showRcmdTips = false
      // if (!this.discountChecked && this.discountInfo) {
      //   const loading = miniLoading.loading()
      //   loading.show()
      //   this.dispatchCoupons4Confirm({promTypes: [], vueInstance: this}).then(
      //     () => {
      //       loading.hide()
      //       this.$refs['ppc'].show()
      //     },
      //   )
      // } else {
      this.$refs['ppc'].show()
      // }
    },
    unSelectCoupon() {
      this.setSelectedCoupon(null)
    }
  },
  components: {
    xCheckbox,
    PopupCoupon,
    couponItemSimplified
  },
  beforeDestroy() {
    this.destroyConfirmPromotions()
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.price-detail {
  background-color: #fff;
  border-radius: rem(16px);
  // border-bottom-left-radius: rem(16px);
  // border-bottom-right-radius: rem(16px);
  ul {
    padding: 0.1rem 0;
    li {
      height: 0.76rem;
      display: flex;
      align-items: center;
      font-size: 0.26rem;
      color: #262626;
      //   line-height: 0.32rem;
      margin-bottom: 0 !important;

      &:first-child {
        margin-bottom: rem(20px);
      }
      .label-ui span {
        color: #262626;
      }
      .promotion-discount {
        font-size: rem(26px);
        color: #ff5900;
        font-weight: bold;
      }
      > div {
        height: inherit;
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333333;
      }
      .label-ui + div {
        flex: 1;
        height: inherit;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      .coupon-ui {
        display: flex;
        align-items: center;
        color: #ff5900;
      }
      .best-coupon {
        position: absolute;
        font-size: rem(20px);
        padding: 0 rem(6px);
        left: rem(144px);
        color: #ff5900;
        margin-left: rem(12px);
        border: 1px solid #ff5900;
        border-radius: rem(4px);
      }
      .no {
        color: #999;
        text-align: right;
        // margin-right: 0.3rem;
      }
      .default {
        color: #262626;
        text-align: right;
        font-weight: normal;
        font-size: 0.26rem;
        margin-right: 0.3rem;
      }
    }
  }
}
.icon-coupon-close {
  display: inline-block;
  width: rem(46px);
  height: rem(34px);
  background: url('~@/assets/images/icon-confirm-delete@3x.png') no-repeat
    center right;
  background-size: rem(34px) auto;
}
.coupon-select-ctn {
  height: inherit;
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: rem(26px);
  margin-right: 0.24rem;
}
</style>
